import React, { useContext, useEffect } from 'react';


import TopBar from './CommonPageElements/TopBar';
import Menu from './CommonPageElements/Menu';
import Footer from './CommonPageElements/Footer';


import { MyContext } from './context/MyContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css'
import './chartSetup';
import { Outlet, useLocation } from 'react-router-dom';

//small hack to process HashRouter when arriving on /login from hyapp.fr
function redirectToLogin() {
  if (window.location.href === (process.env.REACT_APP_PUBLIC_URL + "login")) {
    window.location.href = (process.env.REACT_APP_PUBLIC_URL + "#/login");
  }
}

function App() {

  const { loggedUser, setLoggedUser, setEtablissements, setSelectedEtablissement, setConstants } = useContext(MyContext);

  useEffect(() => {
    document.body.classList.add('has-navbar-fixed-top');
    const savedUser = sessionStorage.getItem("user");
    if (savedUser != "undefined") {
      setLoggedUser(JSON.parse(savedUser));
    }    
    const savedListEtablissement = sessionStorage.getItem("etablissements");
    if (savedListEtablissement != "undefined") {
      setEtablissements(JSON.parse(savedListEtablissement));
    }
    const savedSelectedEtablissement = sessionStorage.getItem("selectedEtablissement");
    if (savedSelectedEtablissement != "undefined") {
      setSelectedEtablissement(JSON.parse(savedSelectedEtablissement));
    }
    const savedConstants = sessionStorage.getItem("constants");
    if (savedConstants && savedConstants != "undefined") {
      setConstants(JSON.parse(savedConstants));
    }

  }, []);

  const location = useLocation();
  var color = "#fbf7f4";
  if (location.pathname === '/' || location.pathname === '/login') {
    color = "#fbf7f4";
  }

  // add is-gapless to columns to remove gap on bottom, but issue with other components
  return (
    <>
    {
      redirectToLogin()
    }
      <TopBar />
      <div className="columns is-fullheight-with-navbar">
        
        {
          loggedUser
            ? (<Menu />)
            : (<></>)
        }
      
        <div className="column is-main-content" style={{backgroundColor: color}}>
          <Outlet />
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
}



export default App;